import { render, staticRenderFns } from "./StaffAndPayrollBreakdown.vue?vue&type=template&id=30bf36a4"
import script from "./StaffAndPayrollBreakdown.vue?vue&type=script&lang=js"
export * from "./StaffAndPayrollBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports